module.exports = __webpack_public_path__ + "img/back_of_deck.2e97d182.png";